import { motion } from "framer-motion";

const stats = [
  {
    value: "98%",
    label: "Patient Satisfaction"
  },
  {
    value: "45%",
    label: "Faster Recovery"
  },
  {
    value: "24/7",
    label: "Continuous Monitoring"
  },
  {
    value: "80%",
    label: "Reduced Readmissions"
  }
];

export const StatsSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-900 to-purple-900 text-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-5xl font-bold mb-4">{stat.value}</div>
              <div className="text-blue-100">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};